var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#A046D3",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 75,
    height: 75,
    rx: 37.5,
    stroke: "url(#paint0_linear_10117_4191)",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10117_4191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.758 57.4865L25.3097 61H54.725L52.2768 57.4865H27.758Z",
    fill: "url(#paint1_linear_10117_4191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0443 44.1656L26.4792 52.1559H24.3964C23.0005 52.1559 21.7874 51.389 21.1516 50.1082C20.5157 48.8275 20.6181 47.3617 21.4293 46.1868L35.4426 25.9446V55.6693H38.8409V15L18.6668 44.1429C17.1211 46.3719 16.9165 49.2733 18.1296 51.7139C19.3428 54.1544 21.7435 55.6693 24.3964 55.6693H32.0443V44.1656Z",
    fill: "url(#paint2_linear_10117_4191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9504 44.1656L53.5156 52.1559H55.5984C56.9943 52.1559 58.2074 51.389 58.8432 50.1082C59.479 48.8275 59.3767 47.3617 58.5655 46.1868L44.5522 25.9446V55.6694H41.1539V15L61.3317 44.1429C62.8773 46.3719 63.082 49.2733 61.8688 51.7139C60.6557 54.1544 58.2549 55.6694 55.6021 55.6694H47.9541V44.1656H47.9504Z",
    fill: "url(#paint3_linear_10117_4191)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10117_4191",
    x1: 39.9987,
    y1: -0.364663,
    x2: 39.9987,
    y2: 79.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10117_4191",
    x1: 39.9985,
    y1: 14.7903,
    x2: 39.9985,
    y2: 60.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10117_4191",
    x1: 39.9985,
    y1: 14.7903,
    x2: 39.9985,
    y2: 60.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10117_4191",
    x1: 39.9985,
    y1: 14.7903,
    x2: 39.9985,
    y2: 60.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988649,
    stopColor: "#6B318B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10117_4191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(17 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserAvatar);
export default __webpack_public_path__ + "static/media/default-user-avatar.b3a75a6675a7f0dcfedc2b97f735b377.svg";
export { ForwardRef as ReactComponent };